<div class="modal-header">
    <h5 class="modal-title">
        <span  class="mx-1">კატალოგის</span> 
        <span *ngIf="!this.editingId">დამატება</span> <span *ngIf="this.editingId">რედაქტირება</span>
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal.emit()"></button>
</div>
<div class="modal-body">
    <form [formGroup]="form">

        <div class="form-floating mb-3">
            <input
                type="text"
                class="form-control"
                formControlName="title"
                id="title"
                placeholder="სათაური"
                required>
            <label for="title">სათაური</label>
            <div class="invalid-feedback">
                error
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-md-6">
                <div class="form-floating">
                    <select class="form-select" id="gg_categories" formControlName="gg_categories">
                        <option value="" disabled selected></option> <!-- საჭიროა label-ისთვის -->
                        <option *ngFor="let category of categories" [value]="category.id">
                        {{ category.title }}
                        </option>
                    </select>
                    <label for="gg_categories">კატეგორია</label>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-floating">
                    <select class="form-select" id="gg_municipality" formControlName="gg_municipality">
                        <option value="" disabled selected></option>
                        <option *ngFor="let m of municipality" [value]="m.id">
                        {{ m.title }}
                        </option>
                    </select>
                    <label for="gg_municipality">მუნიციპალიტეტი</label>
                </div>
            </div>
        </div>

        <div class="form-floating mb-3">
            <editor
                [init]="{
                    base_url: '/tinymce',
                    license_key: 'gpl',
                    suffix: '.min',
                    plugins: 'link image fullscreen',
                    toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | bullist numlist | link image | fullscreen',
                    file_picker_callback: openFileManagerWrapper,
                }"
                formControlName="description"
            ></editor>
        </div>

         <div class="form-floating mb-3">
            <input
            type="datetime-local"
            class="form-control"
            formControlName="postdate"
            id="postdate"
            placeholder="თარიღი"
            required>
            <label for="postdate">თარიღი</label>
            <div class="invalid-feedback">
            error
            </div>
        </div>

        <div class="mt-3 mb-3 row">
            
            <div class="col-md-4 mb-3 d-flex align-items-center flex-column" *ngFor="let i of [1, 2, 3, 4, 5, 6]">
                <img
                *ngIf="form.get('image' + i)?.value"
                [src]="getFullImageUrl(form.get('image' + i)?.value)"
                alt="არჩეული სურათი"
                class="img mb-2"
                />

                <button type="button" class="btn btn-primary" (click)="openFileManagerForImage(i)" [disabled]="loadSave">
                <i class="fi fi-rr-picture"></i> 
                <span *ngIf="form.get('image' + i)?.value"> სურათის შეცვლა</span>
                <span *ngIf="!form.get('image' + i)?.value"> სურათის არჩევა</span>
                </button>

            </div>
        </div>


        <div class="input-group mb-3" >
          <span class="input-group-text" id="youtube"><i class="fi fi-brands-youtube"></i> </span>
          <div class="form-floating">
            <input type="text" formControlName="youtube" id="youtube" class="form-control" placeholder="Youtube ბმული" required />
            <label for="youtube">Youtube ბმული</label>
          </div>
        </div>

        <div class="row mb-3">
            <div class="col-md-6">
                <div class="form-floating">
                    <input
                        type="text"
                        class="form-control"
                        formControlName="x"
                        id="x"
                        placeholder="x"
                        required>
                    <label for="x">x</label>
                    <div class="invalid-feedback">
                        error
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-floating">
                    <input
                        type="text"
                        class="form-control"
                        formControlName="y"
                        id="y"
                        placeholder="y"
                        required>
                    <label for="y">y</label>
                    <div class="invalid-feedback">
                        error
                    </div>
                </div>
            </div>
        </div>

        <div class="input-group mb-3">
            <span class="input-group-text" id="basic-slug">ajaraheritage.ge/catalog/</span>
            <div class="form-floating">
                <input
                    type="text"
                    class="form-control"
                    formControlName="slug"
                    id="slug"
                    placeholder="მენიუს სათაური"
                    required
                    [class.is-invalid]="form.get('slug')?.invalid && form.get('slug')?.touched"
                    [class.is-valid]="form.get('slug')?.valid && !form.get('slug')?.hasError('slugTaken')">
                <label for="slug">ბმული</label>
                <div class="invalid-feedback" *ngIf="form.get('slug')?.hasError('slugTaken')">
                    ეს ბმული უკვე გამოიყენება
                </div>
            </div>
        </div>

        <div class="mt-3 mb-3 row">
            <app-gallery-selector
                [multiselect]="true"
                [isParonama360]="true"
                (selected)="onParonamaGalleryImagesSelected($event)">
            </app-gallery-selector>

          
            <div *ngIf="form.get('gallery_360')?.value?.length" class="mt-3">
                <label class="form-label mb-3">არჩეული სურათები (360 პრევიუ)</label>
                <div
                    cdkDropList
                    class="d-flex flex-wrap gap-3"
                    cdkDropListSortingDisabled="false"
                >
                <div
                    class="gallery-image-preview position-relative"
                    *ngFor="let img of form.get('gallery_360')?.value; let i = index"
                    cdkDrag
                >
                <img [src]="img" class="img-thumbnail" width="150" />
                <span
                  class="delete position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                  (click)="removeGalleryImage(i)">
                  <i class="fi fi-rr-trash"></i>
                </span>
              </div>
            </div>
          </div>

        </div>
        
        
        <button type="button" class="btn btn-outline-secondary" (click)="openMetaFormModal()">
            მეტა მონაცემები
        </button>

    </form>
</div>
<div class="modal-footer d-flex justify-content-between">
  <div>
    <span *ngIf="form.get('author')?.value"><b>ავტორი: </b>{{form.get('author')?.value}}</span>
  </div>
  <div>
    <button type="button" class="btn btn-secondary mx-1" (click)="closeModal.emit()">დახურვა</button>
    <button type="button" class="btn btn-primary" (click)="saveCatalogs()" [disabled]="loadSave">
      <span *ngIf="loadSave" class="spinner-border spinner-border-sm" role="status" ></span> 
      <span *ngIf="!this.editingId">დამატება</span>
      <span *ngIf="this.editingId">შენახვა</span>
    </button>
  </div>
</div>


<ng-template #fileManagerModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">ფაილის არჩევა</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <app-file-manager
      [type]="'image'"
      (fileSelected)="onFileSelectedFromManager($event, modal)">
    </app-file-manager>
  </div>
</ng-template>


<ng-template #metaFormModal let-modal>
  <app-meta-form-modal
    [meta_desc]="form.get('meta_desc')?.value"
    [meta_keys]="form.get('meta_keys')?.value"
    (save)="form.patchValue($event); modal.close()"
  ></app-meta-form-modal>
</ng-template>